<template>
  <v-card>
    <v-card-title>
      <v-row>
        <v-col lg="6"> List Jadwal Mengajar </v-col>
        <v-col lg="6" align="right">
          <v-btn dark color="blue" @click="$router.push('/jadwal/entri')">
            <v-icon>mdi-plus</v-icon>
            Tambah
          </v-btn>
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text>
      <form @submit.prevent="getToFirstPage">
        <v-row>
          <v-col cols="12" lg="4">
            <v-autocomplete
              label="Hari"
              v-model="filter.hari"
              :items="[
                {
                  value: 'senin',
                  text: 'Senin',
                },
                {
                  value: 'selasa',
                  text: 'Selasa',
                },
                {
                  value: 'rabu',
                  text: 'Rabu',
                },
                {
                  value: 'kamis',
                  text: 'Kamis',
                },
                {
                  value: 'jumat',
                  text: 'Jumat',
                },
                {
                  value: 'sabtu',
                  text: 'Sabtu',
                },
              ]"
              @change="getToFirstPage"
              clearable
            ></v-autocomplete>
          </v-col>
          <v-col lg="8" cols="12">
            <v-text-field
              label="Search"
              v-model="filter.search"
              @change="getToFirstPage"
              append-icon="mdi-magnify"
            ></v-text-field>
          </v-col>
        </v-row>
        <button type="submit" hidden="hidden"></button>
      </form>

      <v-btn
        dark
        color="blue"
        @click="modal.filters = true"
        v-if="false"
        class="mb-5"
      >
        Advance Search &nbsp;
        <v-icon>mdi-magnify</v-icon>
      </v-btn>

      <v-data-table
        :footer-props="{
          'items-per-page-options': [5, 10, 20, 50, 100],
        }"
        disable-sort
        :headers="[
          {
            text: 'Guru',
            value: 'guru.nama',
          },
          {
            text: 'Ruang',
            value: 'ruang',
          },
          {
            text: 'Mata Pelajaran',
            value: 'mata_pelajaran.nama',
          },
          {
            text: 'Rombel',
            value: 'rombel',
          },
          {
            text: 'Hari',
            value: 'hari',
          },
          {
            text: 'Jam Ke-',
            value: 'jamkbm',
          },
          {
            text: 'Opsi',
            value: 'actions',
          },
        ]"
        :items="datas"
        :loading="is.loading"
        loading-text="Loading... Please wait"
        :server-items-length="recordsTotal"
        :options.sync="options"
      >
        <template slot="item.rombel" slot-scope="{ item }">
          {{ item.rombel.rombel }}
        </template>

        <template slot="item.hari" slot-scope="{ item }">
          {{ item.hari.toUpperCase() }}
        </template>

        <template slot="item.jamkbm" slot-scope="{ item }">
          <template v-if="item.jam_kbm || item.jam_akhir_kbm">
            Ke-{{ item.jam_kbm.ke }} ({{
              item.jam_kbm.mulai_pukul.slice(0, 5) +
              " - " +
              item.jam_kbm.akhir_pukul.slice(0, 5)
            }})
            <template v-if="item.jam_kbm_akhir">
              s/d Ke-{{ item.jam_kbm_akhir.ke }} ({{
                item.jam_kbm_akhir.mulai_pukul.slice(0, 5) +
                " - " +
                item.jam_kbm_akhir.akhir_pukul.slice(0, 5)
              }})
            </template>
          </template>
          <template v-else>
            {{ item.jam_awal_kbm.slice(0, 5) }} -
            {{ item.jam_akhir_kbm.slice(0, 5) }}
          </template>
        </template>

        <template slot="item.actions" slot-scope="{ item }">
          <v-btn
            icon
            color="blue"
            @click="$router.push('/jadwal/list/' + item.id)"
          >
            <v-icon>mdi-pen</v-icon>
          </v-btn>
          <v-btn
            icon
            color="red"
            @click="
              req = item;
              modal.delete = true;
            "
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card-text>

    <v-dialog v-model="modal.delete">
      <v-card width="450">
        <v-form @submit.prevent="destroy">
          <v-card-title>Hapus List Jadwal Mengajar</v-card-title>
          <v-card-text>Anda yakin menghapus data terpilih?</v-card-text>
          <v-card-actions>
            <v-btn type="submit" text color="blue">Hapus</v-btn>
            <v-btn type="button" text color="red" @click="modal.delete = false"
              >Batal</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="modal.filters">
      <v-card style="min-width: 60vw">
        <v-card-title>Advance Search</v-card-title>
        <v-card-text>
          <MultiFilterJadwalMengajar :filters.sync="filter.filters" />

          <div>
            <v-btn
              dark
              color="blue"
              @click="
                () => {
                  getToFirstPage();
                  modal.filters = false;
                }
              "
            >
              Terapkan
            </v-btn>
            &nbsp;
            <v-btn dark color="red" @click="resetCustomFilters"> Reset </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import AutoCompleteGuru from "../../../components/AutoCompleteGuru.vue";
import AutoCompleteMapel from "../../../components/AutoCompleteMapel.vue";
import AutoCompleteRombel from "../../../components/AutoCompleteRombel.vue";
import MultiFilterJadwalMengajar from "../../../components/jadwal/MultiFilterJadwalMengajar.vue";

export default {
  data() {
    return {
      datas: [],
      modal: {
        delete: false,
        filters: false,
      },
      req: {},
      is: {
        loading: true,
      },
      filter: {
        limit: 10,
        search: "",
        page: 1,
        filters: [],
      },
      options: {},
      recordsTotal: 0,
      isAdmin: localStorage.getItem("xlevel") == "admin",
    };
  },
  components: {
    AutoCompleteGuru,
    AutoCompleteMapel,
    AutoCompleteRombel,
    MultiFilterJadwalMengajar,
  },
  created() {
    this.get();
  },
  watch: {
    options(val) {
      this.filter.limit = val.itemsPerPage;
      this.filter.page = val.page;
      this.get();
    },
  },
  methods: {
    resetCustomFilters() {
      this.filter.filters = [];
      this.getToFirstPage();
    },
    getToFirstPage() {
      console.log(JSON.stringify(this.filter));
      this.options.page = this.filter.page = 1;
      this.get();
    },
    get() {
      this.req = {};
      this.is.loading = true;
      if (!this.$root.app.isAdmin) {
        this.filter.guru_id = this.$root.app.xid;
      }
      if (this.filter.hari == null) {
        this.filter.hari = "";
      }
      this.$root.app.http
        .get("/api/matapelajaran/jadwalmengajar", this.filter)
        .then((res) => {
          this.datas = res.data;
          this.recordsTotal = res.recordsTotal;
          this.is.loading = false;
        });
    },
    destroy() {
      this.$root.app.http
        .del("/api/matapelajaran/jadwalmengajar/" + this.req.id)
        .then((res) => {
          if (res.error) {
            this.$root.app.notif(res.message[0], true);
          } else {
            this.get();
            this.modal.delete = false;
            this.$root.app.notif(res.message);
          }
        });
    },
  },
};
</script>
